module.exports = __webpack_public_path__ + "static/media/fresh-sweet-apricots-on-white-table-with-whole-cantaloupe-4397916.237b7cd0.jpg";